module.exports = "/_next/static/images/06a309a8c314e7b9ec65f5b2ecb64ef1-girl-holding-phone@0.75x.jpg";